import { db } from '../firebase';
import firebase from 'firebase/app';

const COLLECTION = 'in_app_campaigns';

export const getCampaigns = async () => {
  try {
    const snapshot = await db.collection(COLLECTION).orderBy('createdAt', 'desc').get();
    const campaigns = [];
    snapshot.forEach((doc) => {
      campaigns.push({
        id: doc.id,
        ...doc.data(),
        createdAt: doc.data().createdAt ? doc.data().createdAt.toDate() : null,
      });
    });
    return campaigns;
  } catch (error) {
    console.error('Error fetching in-app campaigns:', error);
    // Fallback if orderBy index is missing
    const snapshot = await db.collection(COLLECTION).get();
    const campaigns = [];
    snapshot.forEach((doc) => {
      campaigns.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    return campaigns;
  }
};

export const getCampaignById = async (id) => {
  const doc = await db.collection(COLLECTION).doc(id).get();
  if (!doc.exists) return null;
  return {
    id: doc.id,
    ...doc.data(),
    createdAt: doc.data().createdAt ? doc.data().createdAt.toDate() : null,
  };
};

export const createCampaign = async (data) => {
  const docRef = await db.collection(COLLECTION).add({
    ...data,
    version: 1,
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
  return docRef.id;
};

export const updateCampaign = async (id, data) => {
  await db.collection(COLLECTION).doc(id).update({
    ...data,
    version: firebase.firestore.FieldValue.increment(1),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
};

export const resendCampaign = async (id) => {
  await db.collection(COLLECTION).doc(id).update({
    isActive: true,
    version: firebase.firestore.FieldValue.increment(1),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    resentAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
};

export const deleteCampaign = async (id) => {
  await db.collection(COLLECTION).doc(id).delete();
};

export const toggleCampaignStatus = async (id, currentStatus) => {
  await db.collection(COLLECTION).doc(id).update({
    isActive: !currentStatus,
    version: firebase.firestore.FieldValue.increment(1),
    updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
  });
};
